import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Instagram, Facebook } from "lucide-react";
import { useStore } from "../context/StoreContext";

export const Footer = () => {
  const { settings } = useStore();
  return (
    <footer className="bg-forest text-cream mt-24" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-16 grid md:grid-cols-4 gap-12">
        <div>
          <div className="font-serif text-3xl text-gold">Aadvan</div>
          <div className="text-[10px] tracking-[0.3em] uppercase text-cream/60 mb-4">Dry Fruits</div>
          <p className="text-sm text-cream/70 leading-relaxed">
            Premium, handpicked dry fruits & nuts from Sitapur. Freshness, purity and luxury — delivered to your doorstep.
          </p>
          <div className="flex gap-3 mt-5">
            <a href={settings.instagram || "#"} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="w-9 h-9 rounded-full border border-cream/20 flex items-center justify-center hover:border-gold hover:text-gold transition-colors"><Instagram size={16} /></a>
            <a href={settings.facebook || "#"} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="w-9 h-9 rounded-full border border-cream/20 flex items-center justify-center hover:border-gold hover:text-gold transition-colors"><Facebook size={16} /></a>
          </div>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-gold mb-4">Shop</h4>
          <ul className="space-y-2 text-sm text-cream/70">
            <li><Link to="/category/nuts" className="hover:text-gold transition-colors">Nuts</Link></li>
            <li><Link to="/category/dry-fruits" className="hover:text-gold transition-colors">Dry Fruits</Link></li>
            <li><Link to="/category/gift-boxes" className="hover:text-gold transition-colors">Gift Boxes</Link></li>
            <li><Link to="/category/exotic-collection" className="hover:text-gold transition-colors">Exotic Collection</Link></li>
            <li><Link to="/category/corporate-gifts" className="hover:text-gold transition-colors">Corporate Gifts</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-gold mb-4">Help</h4>
          <ul className="space-y-2 text-sm text-cream/70">
            <li><Link to="/track-order" className="hover:text-gold transition-colors">Track Order</Link></li>
            <li><Link to="/faqs" className="hover:text-gold transition-colors">FAQs</Link></li>
            <li><Link to="/shipping-policy" className="hover:text-gold transition-colors">Shipping Policy</Link></li>
            <li><Link to="/refund-policy" className="hover:text-gold transition-colors">Refund Policy</Link></li>
            <li><Link to="/privacy-policy" className="hover:text-gold transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-gold transition-colors">Terms of Service</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-gold mb-4">Visit Us</h4>
          <ul className="space-y-3 text-sm text-cream/70">
            <li className="flex gap-2"><MapPin size={16} className="text-gold shrink-0 mt-0.5" /> {settings.address}</li>
            <li className="flex gap-2"><Phone size={16} className="text-gold shrink-0 mt-0.5" /> {settings.phone}</li>
            <li className="flex gap-2"><Mail size={16} className="text-gold shrink-0 mt-0.5" /> {settings.email}</li>
          </ul>
          <p className="text-xs text-cream/50 mt-4">Delivery only within 15 KM of Sitapur.</p>
        </div>
      </div>
      <div className="border-t border-cream/10">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-cream/50">
          <span>© {new Date().getFullYear()} {settings.store_name}. All rights reserved.</span>
          <Link to="/admin/login" className="hover:text-gold transition-colors" data-testid="footer-admin-link">Admin Login</Link>
        </div>
      </div>
    </footer>
  );
};
